import React from 'react';
import { useTranslation } from 'react-i18next';

export const RTLWrapper: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { i18n } = useTranslation();
  const isRTL = i18n.language === 'ar';

  return (
    <div className={`${isRTL ? 'rtl' : 'ltr'}`}>
      {children}
    </div>
  );
}; 